import { FC, useState } from "react";
import { Button, Table } from "antd";
import { usePurchaseEnquiryDetailsModel } from "./purchaseEnquiryDetailsModel";
import { RouterParamType } from "@/model/navModel";
import { PrintChangeLog } from "./PrintChangeLog";
import { momentFormat } from "@/utils/utils";
import YhTootip from "@/components/YhTootip";

export const TableBoxChangeLog: FC<RouterParamType> = ({ id, mode }) => {
    const { changeSupplierLogData } = usePurchaseEnquiryDetailsModel();
    const [printVisible, setPrintVisible] = useState<boolean>(false);

    const columns = [
        {
            title: '序号',
            dataIndex: 'key',
            width: 60,
            render: (t: any, r: any, i: number) => i + 1,
        },
        {
            title: '商品编码',
            dataIndex: 'materialCode',
            width: 160,
        },
        {
            title: '商品名称',
            dataIndex: 'materialName',
            width: 140,
        },
        {
            title: '适用车型',
            width: 120,
            dataIndex: 'vehicleModel',
            render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
        },
        {
            title: '规格型号',
            dataIndex: 'model',
            width: 100,
        }, {
            title: '上装品牌',
            width: 110,
            dataIndex: 'upperClothBrand',
        }, {
            title: '底盘品牌',
            width: 110,
            dataIndex: 'chassisBrand',
        },
        {
            title: '单位',
            dataIndex: 'unitName',
            width: 70,
        },
        {
            title: '数量',
            dataIndex: 'num',
            width: 70,
        },
        {
            title: '中标供应商及价格',
            dataIndex: 'old',
            children: [
                {
                    title: '比选后确定供应商',
                    dataIndex: 'oldSupplierName',
                    width: 220,
                    align: 'center',
                },
                {
                    title: '送货价',
                    width: 80,
                    align: 'center',
                    dataIndex: 'oldPrice',
                },
            ]
        },
        {
            title: '变更供应商及价格',
            dataIndex: 'new',
            children: [
                {
                    title: '变更供应商',
                    dataIndex: 'newSupplierName',
                    width: 220,
                    align: 'center',
                },
                {
                    title: '变更送货价',
                    width: 90,
                    align: 'center',
                    dataIndex: 'newPrice',
                },
            ]
        },
        {
            title: '变更原因',
            dataIndex: 'note',
            width: 170,
        },
        {
            title: '所属站点',
            width: 250,
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        },
        {
            title: '变更时间',
            dataIndex: 'createTime',
            width: 120,
            render: (text: any) => momentFormat(text)
        },
    ];

    const action = <>
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => setPrintVisible(true)}
        >打印</Button>
    </>;

    return (
        <>
            {changeSupplierLogData.length > 0 && action}
            <Table
                style={{ marginTop: 10 }}
                bordered
                rowKey={(record: any) => record.id as string}
                columns={columns}
                pagination={false}
                dataSource={changeSupplierLogData}
                scroll={{ x: 'max-content', y: 500 }}
            />
            <PrintChangeLog printVisible={printVisible} setPrintVisible={setPrintVisible} />
        </>
    )
}